import { environment } from '@lla-platform/core/core-util'

export const PAGE_API_URL = {
  pageBaseUrl: `${environment.apiUrl}/pages`,
  publicResources: `${environment.apiUrl}/publicresources`
}
